__turbopack_context__.v({
  "animate": "Toast-module-scss-module__vY3dRq__animate",
  "close": "Toast-module-scss-module__vY3dRq__close",
  "colorStripe": "Toast-module-scss-module__vY3dRq__colorStripe",
  "error": "Toast-module-scss-module__vY3dRq__error",
  "iconCircle": "Toast-module-scss-module__vY3dRq__iconCircle",
  "info": "Toast-module-scss-module__vY3dRq__info",
  "message": "Toast-module-scss-module__vY3dRq__message",
  "slideEnter": "Toast-module-scss-module__vY3dRq__slideEnter",
  "slideExit": "Toast-module-scss-module__vY3dRq__slideExit",
  "slideInLeft": "Toast-module-scss-module__vY3dRq__slideInLeft",
  "slideOutLeft": "Toast-module-scss-module__vY3dRq__slideOutLeft",
  "success": "Toast-module-scss-module__vY3dRq__success",
  "title": "Toast-module-scss-module__vY3dRq__title",
  "toast": "Toast-module-scss-module__vY3dRq__toast",
  "toastBody": "Toast-module-scss-module__vY3dRq__toastBody",
  "toastContent": "Toast-module-scss-module__vY3dRq__toastContent",
});
